'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useContext, useEffect, useMemo, } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import useLocale from '../locale-provider';
import { initI18n } from './i18n-config';
export const TranslationsContext = React.createContext({
    getFullLanguage: (locale) => locale,
    t: ((key) => key),
});
TranslationsContext.displayName = 'TranslationsContext';
const InternalTranslationsProvider = ({ children, }) => {
    const { t, i18n } = useTranslation();
    const getFullLanguage = useCallback((locale) => t(`language|${locale}`), [t]);
    const { selectedLocale } = useLocale();
    useEffect(() => {
        if (!i18n || !selectedLocale)
            return;
        if (i18n.language !== selectedLocale) {
            i18n.changeLanguage(selectedLocale);
        }
    }, [i18n, selectedLocale]);
    const contextValue = useMemo(() => ({ t, getFullLanguage }), [t, getFullLanguage]);
    return (_jsx(TranslationsContext.Provider, { value: contextValue, children: children }));
};
export const TranslationsProvider = ({ children, translationsData, selectedLocale, namespaces, jsonFiles, }) => {
    const i18nInstance = useMemo(() => initI18n(selectedLocale, translationsData, namespaces, jsonFiles), [jsonFiles, namespaces, selectedLocale, translationsData]);
    return (_jsx(I18nextProvider, { i18n: i18nInstance, defaultNS: 'common', children: _jsx(InternalTranslationsProvider, { children: children }) }));
};
export const useTranslations = () => useContext(TranslationsContext);
